import 'url-search-params-polyfill';
import 'fetch-polyfill';

const DEFAULT_FETCH_OPTIONS = {
  mode: 'cors'
};

const DEFAULT_VIDEOS_COUNT = 25;

const isEmbedded = ({ privacy = {} }) => {
  const { embed = 'public', view = 'anybody' } = privacy;

  return (
    ['public', 'whitelist'].includes(embed) &&
    ['anybody', 'disable', 'password'].includes(view)
  );
};

const fetchData = async (url, options, previousVideoData = []) => {
  const response = await fetch(url, { ...DEFAULT_FETCH_OPTIONS, ...options });
  const responseData = await response.json();

  const isFetchAvailable =
    url.searchParams.get('q').includes('videos') && !responseData.error;

  if (!isFetchAvailable) {
    return responseData;
  }

  if (responseData.data) {
    const filteredData = responseData.data.filter(isEmbedded);

    const currentVideoData = [...previousVideoData, ...filteredData];
    const shouldLoadMoreVideos =
      responseData.paging?.next &&
      currentVideoData.length < DEFAULT_VIDEOS_COUNT;

    if (shouldLoadMoreVideos) {
      const nextPageUrl = new URL(url);
      nextPageUrl.searchParams.set('q', responseData.paging.next);

      return fetchData(nextPageUrl, options, currentVideoData);
    }

    return { ...responseData, data: currentVideoData };
  }

  return isEmbedded(responseData) ? responseData : null;
};

export const request = async ({
  apiUrl,
  params = {},
  options = {},
  endpoint
}) => {
  const url = new URL(apiUrl);
  url.searchParams.set('q', endpoint);

  Object.entries(params).forEach(([key, value = '']) => {
    url.searchParams.set(key, value);
  });

  return fetchData(url, options);
};
